import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { useLocation } from "react-router-dom";

import { ROUTES } from "../data/content";
import Home from "./home/Home";
import NotFound from "./general/NotFound";

const App = () => {
  const { pathname } = useLocation();

  //One page site - anything other than the home page is a 404
  const path = pathname.replace(/\/+$/, "") || ROUTES.HOME;

  if (path === ROUTES.HOME) {
    return (
      <Home />
    );
  }

  return (
    <NotFound />
  );
};

export default App;
